import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const VinPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#F0EEF8', // bg-color-vin
            100: '#F0EEF8',
            200: '#d4c9ef',
            300: '#b8a3e6',
            400: '#a680d9',
            500: '#9966ce', // btn-primary
            600: '#8a55c0',
            700: '#514A78', // color-light-violet
            800: '#261D56', // color-violet
            900: '#1a1440',
            950: '#0e0b28'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '#9966ce',
                    contrastColor: '#ffffff',
                    hoverColor: '#8a55c0'
                }
            }
        }
    },
    components: {
        button: {
            root: {
                primary: {
                    background: '{primary.500}',
                    borderColor: '{primary.500}',
                    color: '#ffffff',
                    hoverBackground: '{primary.700}',
                    hoverBorderColor: '{primary.700}',
                    hoverColor: '#ffffff'
                }
            },
            outlined: {
                primary: {
                    hoverBackground: '{primary.500}',
                    activeBackground: '{primary.50}',
                    borderColor: '{primary.800}',
                    color: '{primary.800}'
                }
            }
        },
        checkbox: {
            root: {
                checkedBackground: '{primary.500}',
                checkedBorderColor: '{primary.500}',
                checkedHoverBackground: '{primary.600}',
                checkedHoverBorderColor: '{primary.600}'
            }
        },
        datatable: {
            headerCell: {
                background: '{primary.50}',
                color: '{primary.800}',
                hoverBackground: '{primary.50}',
                selectedBackground: '{primary.50}',
                selectedColor: '{primary.500}'
            },
            sortIcon: {
                color: '{primary.800}',
                hoverColor: '{primary.500}'
            },
            filter: {
                constraint: {
                    selectedBackground: '{primary.50}',
                    selectedFocusBackground: '{primary.50}',
                    selectedColor: '{primary.500}',
                    selectedFocusColor: '{primary.500}'
                }
            }
        },
        datepicker: {
            inputIcon: {
                color: '{primary.800}'
            },
            date: {
                selectedBackground: '{primary.500}',
                rangeSelectedBackground: '{primary.50}'
            }
        },
        floatlabel: {
            root: {
                focusColor: '{primary.500}'
            }
        },
        inputtext: {
            root: {
                borderColor: '{primary.800}',
                focusBorderColor: '{primary.500}'
            }
        },
        multiselect: {
            root: {
                borderColor: '{primary.800}',
                focusBorderColor: '{primary.500}'
            },
            dropdown: {
                color: '{primary.800}'
            },
            option: {
                focusBackground: '{primary.50}',
                focusColor: '{primary.500}',
                selectedBackground: '{primary.50}',
                selectedColor: '{primary.500}',
                selectedFocusBackground: '{primary.50}',
                selectedFocusColor: '{primary.500}'
            }
        },
        paginator: {
            navButton: {
                selectedBackground: '{primary.50}', // bg-color-vin
                selectedColor: '{primary.500}', // btn-primary
                hoverBackground: '{primary.50}',
                hoverColor: '{primary.500}'
            }
        },
        select: {
            root: {
                borderColor: '{primary.800}',
                focusBorderColor: '{primary.500}'
            },
            dropdown: {
                color: '{primary.800}'
            },
            option: {
                focusBackground: '{primary.50}',
                focusColor: '{primary.500}',
                selectedBackground: '{primary.50}',
                selectedColor: '{primary.500}',
                selectedFocusBackground: '{primary.50}',
                selectedFocusColor: '{primary.500}'
            },
            checkmark: {
                color: '{primary.500}'
            }
        }
    }
});
